import LoadingPlaceholder from './LoadingPlaceholder'

export default LoadingPlaceholder
